import "../../assets/stylesheets/components/explanations.scss";

import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import State from "web_modules/State";

export const ExplanationStatus = {
  draft: "draft",
  needs_response: "needs_response",
  needs_review: "needs_review",
  satisfactory: "satisfactory",
  unsatisfactory: "unsatisfactory",
  ignored: "ignored",
};

export const ExplanationType = {
  NoCounterpartyDetected: "NoCounterpartyDetected",
  PossibleDebtObligations: "PossibleDebtObligations",
  PayrollDeposits: "PayrollDeposits",
  MatchedPayrollDeposits: "MatchedPayrollDeposits",
  LargeUnaccountedDeposit: "LargeUnaccountedDeposit",
  LargeUnaccountedDepositNoPayroll: "LargeUnaccountedDepositNoPayroll",
};

export const ExplanationEventType = {
  InitialExplanationsReviewed: "InitialExplanationsReviewed",
  AnsweredExplanationsReviewed: "AnsweredExplanationsReviewed",
};

export function unansweredExplanations(explanations) {
  return explanations.filter((explanation: any) => {
    if (Explanations.isAccountAddPromptExplanation(explanation)) {
      return false;
    }
    if (explanation.status !== ExplanationStatus.needs_response) {
      return false;
    }
    return explanation.response === null || explanation.response === "";
  });
}

interface IExplanationsProps {
  application: any;
  updateApplication: Dispatch<State>;
  location?: {
    state: {
      showIntro: boolean;
    };
  };
}

class Explanations extends React.Component<IExplanationsProps, any> {
  public static isAccountAddPromptExplanation(explanation) {
    return explanation.type_key === ExplanationType.NoCounterpartyDetected;
  }

  public static isGroupedExplanation(explanation) {
    return explanation.type_key === ExplanationType.PossibleDebtObligations;
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  application: state.borrower.loanApplication,
});

const mapDispatchToProps = dispatch => ({
  updateApplication(application) {
    dispatch({
      type: "UPDATE_APPLICATION",
      payload: application,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Explanations);
